<div class="tw-rounded-xl tw-bg-[#f5f5f5] tw-h-full tw-flex tw-flex-col" *ngIf="showComponent">
  <modal-header
    [showBackButton]="
      isMobile() &&
      chooseAccountDialog &&
      (wizardStage === 'select-account' || wizardStage === 'add-transaction')
    "
    [title]="'uploadNewFile' | i18n"
    [showCloseButton]="!uploading"
    [isMatDialog]="false"
    (onBackClicked)="wiz.goBack()"
    (onCloseClicked)="handleClose()"
  ></modal-header>

  <div class="modal-body tw-flex tw-flex-col tw-justify-between tw-flex-1">
    <div [hidden]="!chooseAccountDialog" class="tw-h-full">
      <div class="tw-h-full tw-w-full">
        <div class="tw-flex tw-flex-col tw-h-full tw-max-w-[100vw] tw-w-full">
          <!-- cabinet-upload-panes (see .scss): preview | (indicator + content) when wide;
               collapses to indicator -> preview -> content when narrow. -->
          <form name="accountForm" class="cabinet-upload-panes tw-p-2 xs:tw-p-0">
            <!-- Stage indicator: top of the right column when wide, top of the stack when narrow. -->
            <div
              class="cabinet-upload-panes__indicator tw-flex tw-items-center tw-justify-between tw-gap-4 tw-border-0 tw-border-b tw-border-color-border-subtle sm:tw-gap-2"
            >
              <span class="tw-whitespace-nowrap tw-font-medium 2xl:tw-hidden">{{
                wizardStageTitle
              }}</span>
              <!-- 2-row grid (3 cols × 2 rows): labels on row 1, bars on the shared row 2 so the
                   progress bars stay aligned even when a label wraps. Labels shrink on mobile. -->
              <div
                class="tw-grid tw-w-full tw-grid-cols-3 tw-gap-x-[1px] tw-gap-y-1 tw-rounded-lg tw-bg-dt-surface-card tw-px-6 tw-py-2 sm:tw-px-3"
              >
                <span
                  class="tw-text-sm tw-leading-tight sm:tw-text-[11px]"
                  [ngClass]="{ 'tw-text-primary': wizardStageIndex >= 0 }"
                  >{{ "fileDetails" | i18n }}</span
                >
                <span
                  class="tw-text-sm tw-leading-tight sm:tw-text-[11px]"
                  [ngClass]="{ 'tw-text-primary': wizardStageIndex >= 1 }"
                  >{{ "selectAccounts" | i18n }}</span
                >
                <span
                  class="tw-text-sm tw-leading-tight sm:tw-text-[11px]"
                  [ngClass]="{ 'tw-text-primary': wizardStageIndex >= 2 }"
                  >{{ "addTransactions" | i18n }}</span
                >
                <div
                  class="tw-h-1 tw-w-full tw-self-end tw-rounded-l-xl"
                  [ngClass]="wizardStageIndex >= 0 ? 'tw-bg-primary' : 'tw-bg-white'"
                ></div>
                <div
                  class="tw-h-1 tw-w-full tw-self-end"
                  [ngClass]="wizardStageIndex >= 1 ? 'tw-bg-primary' : 'tw-bg-white'"
                ></div>
                <div
                  class="tw-h-1 tw-w-full tw-self-end tw-rounded-r-xl"
                  [ngClass]="wizardStageIndex >= 2 ? 'tw-bg-primary' : 'tw-bg-white'"
                ></div>
              </div>
            </div>

            <!-- File preview. Always shown when wide; when narrow it's hidden on the
                 add-transaction stage (re-openable via the toggle) and shown otherwise. The
                 "Full Preview" button still opens the full-screen sheet for detailed viewing.
                 mappedRows feeds the mapped-statement table; remap re-opens the column-mapping
                 dialog; removeFile resets the pending statement import. -->
            <app-file-upload
              class="cabinet-upload-panes__preview"
              [class.cabinet-upload-panes__preview--collapsed]="!isPreviewVisible"
              [mappedRows]="statementMappedRows"
              (selectedFile)="receivedSelectedFile($event)"
              (removeFile)="clearSelectedFile()"
            ></app-file-upload>

            <div class="cabinet-upload-panes__content tw-flex tw-min-h-0 tw-flex-col tw-gap-6">
              <!-- Preview toggle: narrow-only (hidden via .scss when wide) -->
              <button
                *ngIf="isAddTransactionStage"
                type="button"
                (click)="showPreview = !showPreview"
                class="cabinet-upload-panes__preview-toggle tw-ml-auto tw-flex tw-items-center tw-gap-1 tw-bg-transparent tw-text-sm tw-font-medium tw-text-primary hover:tw-underline"
              >
                {{ (showPreview ? "hidePreview" : "showPreview") | i18n }}
              </button>
              <!-- New Add Balance Wizard. prefill carries the parsed statement (dates, account,
                   balances, transactions) so a mapped import lands pre-filled. -->
              <app-add-balance-wizard
                #wiz
                class="tw-h-full"
                [uploadedFileName]="selectedFile?.name"
                [selectedFile]="selectedFile"
                [prefill]="statementImport"
                (fileNameChanged)="onFileNameChanged($event)"
                (stageChanged)="onWizardStageChanged($event)"
                (saveRequested)="handleSaveAndAddLater($event)"
              ></app-add-balance-wizard>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
